import styled from 'styled-components';
import { ToolbarButton, CommonState } from '../../../../Common/styled/Button';

export const StyledLoading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledWaveformWrapper = styled.div`
  // min-width: 0;
  // min-height:0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  // display: grid;
  // grid-template-columns: 1fr;
  // grid-template-rows: 1fr 3fr 1fr;
`;

export const StyledDropdownButtonWrapper = styled.div`
  background: ${(props) => props.theme.colors.gray700};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8% 2% 10% 34%;
  margin: 0;
`;

export const StyledLayoutsButton = styled(ToolbarButton)`
  background: ${(props) => props.theme.colors.gray700};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8%;
  margin: 0;
  ${CommonState}
`;

export const StyledPatientInfoWrapper = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
padding:1%;
}
`;

export const StyledPatientInfoBlock = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column wrap;
  overflow: visible;
  font-size: 0.9em;
  padding: 0;
  margin: 0;
  width: 300px;
  & p {
    color: ${(props) => props.theme.colors.smokeWhite};
    padding: 0;
    margin: 0;
    font-size: 1.1em;

    &.textObservation {
      height: 2em;
      line-height: 1em;
      text-overflow: ellipsis;
      margin-bottom: 12px;
      cursor: pointer;
      word-break: break-all;
      overflow: hidden;
      user-select: text;

      &:hover {
        overflow: visible;
        white-space: normal;
        height: auto;
        position: absolute;
        margin-top: -30px;
        width: 90%;
        background: #0c0e11;
        border: 1px solid white;
        padding: 10px;
        color: ${(props) => props.theme.colors.smokeWhite};
      }
    }
  }
`;

export const StyledPatientInfoRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'flex-start')};
`;
